import { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router";
import { useUpdateNewOrder } from "@/queries/order/useUpdateNewOrder";
import { useCatalog } from "@/queries/useCatalog";
import { calculateOrderValues } from "@/util/order";
import { Order } from "@/api/SolarCloudApi";

interface UseSearchParamUpdatesOptions {
  order?: Order;
  enabled?: boolean;
}
//TODO: REFACTOR this logic.
export function useSearchParamUpdates({
  order,
  enabled = true,
}: UseSearchParamUpdatesOptions = {}) {
  const navigate = useNavigate();
  const { data: catalog } = useCatalog();
  const [searchParams] = useSearchParams();

  const { mutate: updateOrder, isPending: isUpdating } = useUpdateNewOrder({
    mutationConfig: {
      onError: (error) => {
        console.error("Error updating order:", error);
      },
    },
  });

  const discountCode = searchParams.get("discount");
  const panelsParam = searchParams.get("panels");

  useEffect(() => {
    if (!enabled || !order || !catalog || isUpdating) return;
    let updatedOrder = { ...order };
    let needsUpdate = false;

    // Handle panels parameter
    if (panelsParam !== null) {
      const parsed = parseInt(panelsParam, 10);
      const panelsCount = parsed >= 0 ? parsed : 0;

      // Find the first AVAILABLE (enabled) product — skip sold-out ones
      const firstAvailableProduct = catalog.find((p) => p.enabled === true);
      if (firstAvailableProduct) {
        const newUnits = panelsCount * firstAvailableProduct.wattPanelSize!;
        const newItem = {
          product: firstAvailableProduct,
          units: newUnits,
          unitPrice: firstAvailableProduct.wattPriceCurrent,
        };

        updatedOrder.items = [newItem];
        needsUpdate = true;
      }
    }

    // Handle discount parameter
    if (discountCode !== null && discountCode.length >= 1) {
      if (!order.discount || order.discount.code !== discountCode) {
        console.log("Processing search params 2");

        updatedOrder.discountCode = discountCode;
        needsUpdate = true;
      }
      if (order?.discount?.code === discountCode) {
        console.log("Clearing discount code from URL");
        // if the discount code is already applied, clear the search param
        const newSearchParams = new URLSearchParams(searchParams);
        newSearchParams.delete("discount");
        navigate({ search: newSearchParams.toString() }, { replace: true });
      }
    }

    if (needsUpdate) {
      console.log("Updating order with search params", updatedOrder);
      // Calculate order values if items were updated
      if (panelsParam !== null && updatedOrder.items) {
        console.log("Processing search params 3");
        const discountPercentage =
          order?.fullPrice! > 0
            ? (order?.totalDiscount! / order?.fullPrice!) * 100
            : 0;
        const orderValues = calculateOrderValues(
          updatedOrder,
          discountPercentage
        );
        updatedOrder = { ...updatedOrder, ...orderValues };
      }

      updateOrder(updatedOrder);

      // Clear search parameters
      const newSearchParams = new URLSearchParams(searchParams);
      console.log(newSearchParams);
      if (panelsParam !== null) newSearchParams.delete("panels");
      if (discountCode !== null) {
        console.log("Clearing discount code from URL");
        newSearchParams.delete("discount");
      }
      navigate({ search: newSearchParams.toString() }, { replace: true });
    }
  }, [
    enabled,
    discountCode,
    panelsParam,
    order,
    catalog,
    isUpdating,
    updateOrder,
    searchParams,
    navigate,
  ]);

  return {
    isUpdating,
    hasSearchParams: panelsParam !== null || discountCode !== null,
  };
}
